"use client";

import React from "react";

import {
  ModalContainer,
  type ModalContainerProps,
  ModalContent,
  type ModalContentProps,
} from "./components";

export interface ModalProps
  extends Omit<ModalContainerProps, "children">, ModalContentProps {}

export const Modal: React.FC<ModalProps> = ({
  open,
  onOpenChange,
  ...contentProps
}) => {
  return (
    <ModalContainer open={open} onOpenChange={onOpenChange}>
      <ModalContent {...contentProps} isDismissible={Boolean(onOpenChange)} />
    </ModalContainer>
  );
};
